import actionTypes from './actionTypes'

const storefrontActions = {
	initializeStoreFrontOwner() {
		return {
			type: actionTypes.STOREFRONT_OWNER_INITIALIZE,
		}
	},
	addLessonsSelected() {
		return {
			type: actionTypes.STOREFRONT_ADD_LESSONS_SELECTED,
		}
	},

	addGradesSubjects() {
		return {
			type: actionTypes.STOREFRONT_ADD_GRADES_SUBJECT_OPEN,
		}
	},

	saveTeacherInfo(values) {
		return {
			...values,
			type: actionTypes.STOREFRONT_ADD_GRADES_SUBJECT_SAVE,
		}
	},

	lessonsPickerSearchLessons() {
		return {
			type: actionTypes.STOREFRONT_LESSONS_PICKER_SEARCH_LESSONS,
		}
	},

	lessonsPickerInit() {
		return {
			type: actionTypes.STOREFRONT_INIT_SEARCH_LESSONS,
		}
	},

	lessonsPickerSaveLessons() {
		return {
			type: actionTypes.STOREFRONT_LESSONS_PICKER_SAVE_LESSONS,
		}
	},

	lessonsPickerCancel() {
		return {
			type: actionTypes.STOREFRONT_LESSONS_PICKER_CANCEL,
		}
	},

	subjectsGradesModalCancel() {
		return {
			type: actionTypes.STOREFRONT_ADD_GRADES_SUBJECT_CANCEL,
		}
	},

	subjectsGradesModalClose() {
		return {
			type: actionTypes.STOREFRONT_ADD_GRADES_SUBJECT_CLOSE,
		}
	},


	loadMoreLessons() {
		return {
			type: actionTypes.STOREFRONT_OWNER_LOAD_NEXT_PAGE,
		}
	},


	loadMoreVisitorLessons() {
		return {
			type: actionTypes.STOREFRONT_VISITOR_LOAD_NEXT_PAGE,
		}
	},

	lessonsPickerClose() {
		return {
			type: actionTypes.STOREFRONT_LESSONS_PICKER_CLOSE,
		}
	},

	removeLesson(entityUID, entityID) {
		return {
			type: actionTypes.STOREFRONT_REMOVE_LESSON,
			entityUID,
			entityID,
		}
	},

	removeLesson_confirm(entityUID) {
		return {
			type: actionTypes.STOREFRONT_REMOVE_LESSON_CONFIRMED,
			entityUID,
		}
	},

	removeLesson_cancel() {
		return {
			type: actionTypes.STOREFRONT_REMOVE_LESSON_CANCELLED,
		}
	},

	previewLesson(entityUID) {
		return {
			type: actionTypes.STOREFRONT_PREVIEW_LESSON,
			entityUID,
		}
	},

	initializeStoreFrontVisitor(ownerId) {
		return {
			type: actionTypes.STOREFRONT_VISITOR_INITIALIZE,
			ownerId,
		}
	},

	hoverSortLessons(sourceUID, targetUID) {
		return {
			type: actionTypes.STOREFRONT_OWNER_SORT_HOVER_LESSON,
			sourceUID,
			targetUID,
		}
	},

	sortLessonsRelease() {
		return {
			type: actionTypes.STOREFRONT_OWNER_SORT_LESSONS_RELEASE,
		}
	},

	dragLessonStartHandler(entityUID) {
		return {
			type: actionTypes.STOREFRONT_OWNER_SORT_START,
			entityUID,
		}
	},

	submitBio(value) {
		return {
			type: actionTypes.STOREFRONT_OWNER_SEND_SUBMITTED_BIO,
			value,
		}
	},

	initializeBioForm() {
		return {
			type: actionTypes.STOREFRONT_OWNER_INITIALIZE_BIO_FORM,
		}
	},

	closeBioForm() {
		return {
			type: actionTypes.STOREFRONT_OWNER_CLOSE_BIO_FORM,
		}
	},

	bioFormChange(value) {
		return {
			type: actionTypes.STOREFRONT_OWNER_BIO_FORM_CHANGE,
			value,
		}
	},

	initializePreview() {
		return {
			type: actionTypes.STOREFRONT_INITIALIZE_PREVIEW,
		}
	},

	followOwner(ownerUID) {
		return {
			type: actionTypes.STOREFRONT_VISITOR_FOLLOW_OWNER,
			ownerUID,
		}
	},

	unFollowOwner(ownerUID) {
		return {
			type: actionTypes.STOREFRONT_VISITOR_UNFOLLOW_OWNER,
			ownerUID,
		}
	},

	shareStorefront(ownerId) {
		return {
			type: actionTypes.STOREFRONT_SHARE,
			ownerId,
		}
	},

	finalizeStoreFront() {
		return {
			type: actionTypes.STOREFRONT_FINALIZE,
		}
	},
}

export default storefrontActions
